const startOfDay = (date) => new Date(
  date.getFullYear(),
  date.getMonth(),
  date.getDate(),
);

export const formatRecruiterOnlineStatus = ({
  isOnline,
  lastOnlineAt,
  locale = "sv",
  now = new Date(),
  translate,
}) => {
  if (isOnline) {
    return {label: translate("recruiters.list.online.now"), dateTime: null, title: null};
  }

  const date = lastOnlineAt ? new Date(lastOnlineAt) : null;
  if (!date || Number.isNaN(date.getTime())) return null;

  const normalizedLocale = locale?.toLowerCase().startsWith("en") ? "en" : "sv";
  const time = new Intl.DateTimeFormat(normalizedLocale, {
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
  const fullDate = new Intl.DateTimeFormat(normalizedLocale, {
    dateStyle: "long",
    timeStyle: "short",
  }).format(date);
  const dayDifference = Math.round(
    (startOfDay(now).getTime() - startOfDay(date).getTime()) / 86400000,
  );

  if (dayDifference === 0) {
    return {
      label: translate("recruiters.list.online.today", {time}),
      dateTime: date.toISOString(),
      title: fullDate,
    };
  }

  if (dayDifference === 1) {
    return {
      label: translate("recruiters.list.online.yesterday", {time}),
      dateTime: date.toISOString(),
      title: fullDate,
    };
  }

  const dateAndTime = new Intl.DateTimeFormat(normalizedLocale, {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
  return {
    label: translate("recruiters.list.online.date", {date: dateAndTime}),
    dateTime: date.toISOString(),
    title: fullDate,
  };
};
